export const config = {
  axes: {
    y: {
      show: true,
      tickSizeInner: 0,
      tickLineColour: "white",
      domainColour: "white",
      textColour: "grey",
      fontSize: 12,
      fontWeight: 400,
      offset: -20,
      format: ".2f",
      label: {
        colour: "grey",
        fontSize: 14,
        fontWeight: 400,
        margin: -50,
        text: "Forward 21d Price Return",
      },
    },
    x: {
      show: true,
      tickSizeInner: 0,
      tickLineColour: "white",
      domainColour: "white",
      textColour: "grey",
      fontSize: 12,
      fontWeight: 400,
      label: {
        colour: "grey",
        fontSize: 14,
        fontWeight: 400,
        margin: 40,
        text: "Sum of V-Scores Across Time Horizons",
      },
    },
  },
  layout: {
    margin: {
      top: 100,
      right: 50,
      bottom: 60,
      left: 90,
    },
  },
  svg: { Background: "#ffffff", border: "none" },
  border: { stroke: "#f6f6f6", strokeWidth: 1 },
  header: {
    text: "History of V-Score Forward Price Performance",
    colour: "#CBA266",
    fontSize: 14,
    fontWeight: 600,
    margin: { left: 10, top: 20 },
  },
  refLine: { stroke: "grey", strokeWidth: 2 },
  circle: { radius: 6, strokeWidth: 2 },
  tooltips: {
    active: true,
    hovercolour: "#182235",
    text: {
      label: { fontSize: 10, fontWeight: 600, color: "#000000" },
      content: { fontSize: 10, fontWeight: 400, color: "#000000" },
      seperator: { fontSize: 10, fontWeight: 400, color: "#000000" },
    },
    box: {
      width: 400, //296,
      height: 100,
      fill: "#DFDFDF",
      stroke: "#DFDFDF",
      strokeWidth: 1,
      radius: 4,
    },
    triangle: {
      size: 64,
      marginTop: -1,
      mousetoboxgap: 20,
    },
    table: { padding: 4, border: "none", backgroundColor: "none" },
    tr: { seperator: ":" },
    td: {
      align: { label: "left", content: "left" },
      padding: {
        label: { left: 10, right: 5 },
        content: { left: 5, right: 10 },
      },
    },
  },
};
